export class CBU{
    cbu:string;
    tipoBancoInterlocutor:number;
    enUso:boolean;
}
